<template>
  <el-table
    :border="true"
    id="rebateSetTable"
    :data="incomeList"
    show-summary
    :summary-method="getSummaries"
    :max-height="tableHeight"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    ref="table"
    class="income-table"
  >
    <el-table-column
      v-for="(item, i) in column"
      :prop="item.key"
      :label="item.name"
      :key="i"
      :sortable="item.sort"
      :sort-method="item.sortMethod"
      :width="item.width"
      :min-width="200"
      :fixed="item.key == 'date' || item.key == 'geo'"
    >
      <el-table-column
        :prop="item.key"
        :label="totalColumn[i] + ''"
        :width="item.width"
        :key="i"
        :min-width="200"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row[item.key] ? item.unit : null
            }}{{ scope.row[item.key] ? scope.row[item.key] : "-" }}</span
          >
        </template>
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 200,
    };
  },
  props: {
    incomeList: Array,
    column: Array,
    loading: Boolean,
    totalColumn: Array,
  },
  methods: {
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable"),
          xlsxParam
        );
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "收入报表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        let unitArr = this.column.filter((v) => v.key == column.property);

        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2);
          if (unitArr[0].unit) {
            sums[index] = unitArr[0].unit + sums[index];
          }
        } else {
          sums[index] = "-";
        }
      });
      this.$emit("computTotalColumn", sums);
      return [];
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}
</style>

<style lang="less">
// .el-pagination--small .arrow.disabled, .el-table .hidden-columns, .el-table td.is-hidden>*, .el-table th.is-hidden>*, .el-table--hidden
// .income-table .el-table__header-wrapper th.is-hidden > *,
// .income-table .el-table__header-wrapper .el-table td.is-hidden > * {
//   visibility: inherit;
// }
.el-pagination--small .arrow.disabled,
.el-table .hidden-columns,
.el-table td.is-hidden > *,
.el-table th.is-hidden > *,
.el-table--hidden {
  visibility: inherit;
}
.income-table .cell {
  white-space: nowrap;
  text-overflow: initial;
}
</style>
